import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import './UnsubscribePage.css';

const UnsubscribePage = () => {
    const [params] = useSearchParams();
    const email = params.get('email') || '';
    const token = params.get('token') || '';
    const [state, setState] = useState('ready');
    const [error, setError] = useState('');

    const unsubscribe = async () => {
        setState('loading');
        setError('');
        try {
            await axios.post(`${API_BASE_URL}/mailings/unsubscribe`, { email, token });
            setState('done');
        } catch (err) {
            setState('ready');
            setError(err.response?.data?.message || 'Не удалось отписаться');
        }
    };

    return (
        <div className="unsubscribe-page">
            <section>
                {state === 'done' ? (
                    <>
                        <h1>Вы отписаны</h1>
                        <p>Согласие на рассылку для {email || 'этого адреса'} снято. Новые рассылки на него больше не придут.</p>
                    </>
                ) : (
                    <>
                        <h1>Отписаться от рассылки</h1>
                        <p>Письма с информацией о группах перестанут приходить на {email || 'этот адрес'}.</p>
                        {error && <p className="unsubscribe-error">{error}</p>}
                        <button type="button" onClick={unsubscribe} disabled={state === 'loading' || !email || !token}>
                            {state === 'loading' ? 'Отписываем…' : 'Отписаться'}
                        </button>
                    </>
                )}
            </section>
        </div>
    );
};

export default UnsubscribePage;
